import React from 'react';
import { aiDp } from '../../../../../utils/px2dp';
import utils from '../../../../../utils/utils';

const K_BLACK_THEME_IMG = 'http://static.shihuocdn.cn/admin/files/20230612/32466d3f9e1219bf5332cdee726f1ace.webp';
const K_NORMAL_THEME_IMG = 'http://static.shihuocdn.cn/admin/files/20220622/60c4ccd1c3763097cfa5e67c1ca3fc24.webp';

const BottomLoading = (props) => {
    const { hasMore } = props;

    if (hasMore) {
        return (
            <div
                style={{
                    width: '100%',
                    height: aiDp(68),
                    marginBottom: utils.isIphoneX() ? 34 : 0,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                }}
            >
                <img
                    src={K_NORMAL_THEME_IMG}
                    alt="refresh"
                    style={{
                        width: aiDp(16),
                        height: aiDp(16),
                        marginRight: 4
                    }}
                />
                <p
                    style={{
                        color: '#999',
                        fontSize: aiDp(12),
                        fontFamily: 'PingFangSC-Regular',
                    }}
                >
                    加载中...
                </p>
            </div>
        );
    } else {
        return (
            <div
                style={{
                    width: '100%',
                    height: aiDp(68),
                    marginBottom: utils.isIphoneX() ? 34 : 0,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <div
                    style={{
                        width: aiDp(20),
                        height: 1,
                        backgroundImage: 'linear-gradient(to right, rgba(153,153,153,0), #999999)',
                    }}
                />
                <p
                    style={{
                        color: '#999',
                        fontSize: aiDp(12),
                        fontFamily: 'PingFangSC-Regular',
                        marginLeft: aiDp(4),
                        marginRight: aiDp(4),
                        textAlign: 'center',
                    }}
                >
                    没有更多了
                </p>
                <div
                    style={{
                        width: aiDp(20),
                        height: 1,
                        backgroundImage: 'linear-gradient(to right, #999999, rgba(153,153,153,0))',
                    }}
                />
            </div>
        );
    }
};

export default BottomLoading;



// WEBPACK FOOTER //
// ./components/pipeline-goodsRecommend/lib/SHCard/widgets/BottomLoading.js